import { GetServerSideProps } from 'next';
import CategoryApi from '@lambda/apis/src/category';
import { CategoryTree } from '@lambda/apis/src/category/types';
import axios from 'axios';
import { REDIRECT_HOME } from '@/lib/common';
import {
  getAllcategoryOptionsFromCategory,
  getCategoryCollectionProps,
} from '@/components/collections-v2/category/helpers';
import { SortValue } from '@/lib/collection-search-helpers';
import CategoryCollectionPage from '@/components/collections-v2/common/Collections/CollectionPage';
import CollectionLayout from '@/components/collections-v2/common/Collections/CollectionLayout';
import {
  CollectionProps,
  CollectionServerSideProps,
} from '@/components/collections-v2/common/types';
import settings from '@/settings';

const categoryApi = new CategoryApi();

type Path = { pk: string };

export const getServerSideProps: GetServerSideProps<any, Path> = async ({
  query,
}) => {
  const { handle } = query;
  const pk = query.pk as string;
  const sort = query.sort as SortValue | undefined;

  if (!pk || !handle) return REDIRECT_HOME;

  const category =
    process.env.STAGE === 'prod'
      ? await categoryApi.fetchCategoryByPk(
          pk,
          {
            includes: ['children', 'warrantyInfo'],
          },
          settings.store,
        )
      : ((await axios
          .get(
            `https://reebelo.com/api/categories/${pk}?includes[]=children&includes[]=warrantyInfo&store=${settings.store}`,
          )
          .then((res) => res.data)) as CategoryTree);

  if (!category) return REDIRECT_HOME;

  const categoryOptions = getAllcategoryOptionsFromCategory(category);

  if (categoryOptions.length === 0) return REDIRECT_HOME;

  const categoryCollectionResults = (await getCategoryCollectionProps(
    query,
    {
      variantFilters: { categories: categoryOptions },
      sort: sort ?? 'best-selling',
    },
    { includes: ['options', 'pagination', 'priceRange'] },
  )) as CollectionServerSideProps;

  const props: CollectionProps = {
    ...categoryCollectionResults,
    pageTitle: category.name,
    categoryWarrantyInfo: category?.warrantyInfo?.[settings.store],
    categoryPk: pk,
  };

  return { props };
};

const Category = (props: CollectionProps) => (
  <CollectionLayout key={props.pageTitle} {...props}>
    <CategoryCollectionPage {...props} />
  </CollectionLayout>
);

export default Category;
